import { getCourseType, getCourses, getCourseByTag } from "@/api/course";

export default {
  namespaced: true,
  state: {
    zxCourses: [],
    qiTaLanMu: [],
    gzCourses: [],
    yhshoueyeCourse: [],
    gzshoueyeCourse: [],
  },
  getters: {
    getZxCourses: (state) => state.zxCourses,
    getGzCourses: (state) => state.gzCourses,
    getQiTaLanMu: (state) => state.qiTaLanMu,
    getYhshoueyeCourse: (state) => state.yhshoueyeCourse,
    getGzshoueyeCourse: (state) => state.gzshoueyeCourse,
  },
  mutations: {
    setZxCourses(state, payload) {
      state.zxCourses = payload;
    },
    setGzCourses(state, payload) {
      state.gzCourses = payload;
    },
    setQiTaLanMu(state, payload) {
      state.qiTaLanMu = payload;
    },

    setYhshoueyeCourse(state, payload) {
      state.yhshoueyeCourse = payload;
    },
    setGzshoueyeCourse(state, payload) {
      state.gzshoueyeCourse = payload;
    },
  },
  actions: {
    // 获取专项 分类
    async getZxZk({ commit, state }) {
      // 先获取菜单栏目
      const { results } = await getCourseType({
        platformId: process.env.VUE_APP_PLATFORM_ID,
      });

      const qitaLanMu = [];
      const qitaLanMuSeries = [];
      // 再分别获取内容
      if (results && results.length > 0) {
        for (const item of results) {
          const { results } = await getCourses({ subjectId: item.subjectId });

          // 公众用户课程
          if (item.subjectName == "公众用户专栏") {
            if (results && results.pageSeriesCourse.records.length > 0) {
              // 默认选中第一个话题
              results.pageSeriesCourse.records[0]["isActive"] = true;
              commit("setGzCourses", results.pageSeriesCourse.records);
            }
            continue;
          }

          // 医护人员里面的十一个专项
          if (item.subjectName == "专项") {
            if (results && results.pageSeriesCourse.records.length > 0) {
              commit("setZxCourses", [
                ...results.pageSeriesCourse.records,
                // 加了个死数据
                {
                  columnId: 999,
                  columnName: "阿尔茨海默病专区",
                  columnIntroduction:
                    "https://nnmtph5.morehealth.net.cn/platform/6",
                },
              ]);
            }
            continue;
          }

          // 其它栏目
          qitaLanMu.push(item);
          item.seriesCourses = results.pageSeriesCourse.records;
        }

        commit("setQiTaLanMu", qitaLanMu);
      }
    },

    // 获取首页课程
    async getShouYeCourses({ commit, state }) {
      const { results } = await getCourseByTag({
        tagName: "医护人员首页课程标签",
        pageNo: 1,
        pageSize: 99,
      });
      if (results && results.records.length > 0) {
        commit("setYhshoueyeCourse", results.records);
      }

      const { results: results2 } = await getCourseByTag({
        tagName: "公众用户首页课程标签",
        pageNo: 1,
        pageSize: 99,
      });
      if (results2 && results2.records.length > 0) {
        commit("setGzshoueyeCourse", results2.records);
      }
    },
  },
};
